import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleFilledSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M12 8c3 4.5 7.5 9 12 12-4.5 3-9 7.5-12 12-3-4.5-7.5-9-12-12 4.5-3 9-7.5 12-12"
                        fill="currentColor"
                    />
                    <path
                        d="M25.333 0C27 2.5 29.5 5 32 6.667c-2.5 1.666-5 4.166-6.667 6.666-1.666-2.5-4.166-5-6.666-6.666C21.167 5 23.667 2.5 25.333 0"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleFilledSize32Glyph.displayName = 'HyperstarSparkleFilledSize32Glyph';
